<template>
	<div class="app-detail-card">
		<div class="app-detail-card__inner">
			<div class="app-detail-card__title">
				<div v-for="(item, index) in titleItemList" :key="index">
					{{ item }}
				</div>
				<slot name="title"></slot>
			</div>

			<div v-if="headerContent" class="app-detail-card__header">
				<div>
					{{ headerContent.label }}
				</div>
				<div>
					{{ headerContent.value }}
				</div>
			</div>

			<div class="app-detail-card__body" :style="bodyContentStyles">
				<ul v-if="bodyContentList" class="app-detail-card-body-content-list">
					<li
						class="app-detail-card-body-content-list__item"
						v-for="(item, index) in bodyContentList"
						:key="index"
					>
						<div
							class="
								app-detail-card-body-content-list__item-content
								app-detail-card-body-content-list__item-content--title
							"
						>
							{{ item.label }}
						</div>
						<div
							class="
								app-detail-card-body-content-list__item-content
								app-detail-card-body-content-list__item-content--text
							"
						>
							{{ item.value }}
						</div>
					</li>
				</ul>
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		titleItemList: {
			type: Array,
			default: () => [],
		},
		headerContent: {
			type: Object,
			default: () => {},
		},
		bodyContentList: {
			type: Array,
			default: () => [],
		},
		bodyContentStyles: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
